document.addEventListener("DOMContentLoaded", function () {
  const moduleActive = true;
  const debug = false;

  var dataProducts = {
    1: 46069180596442,
    2: 46069180629210,
    3: 46069180661978,
    4: 46069180694746,
  };

  var titleText = "Order Protection";
  var subtitleText = "Protection for Damage, Loss, Theft & More!";

  function getURLParameter(name) {
    var regex = new RegExp("[?&]" + name + "=([^&#]*)");
    var results = regex.exec(window.location.href);
    return results ? decodeURIComponent(results[1]) : null;
  }

  var customBlock = `
      <div class="custom-products-protection js-custom-pp" id="custom-pp">
          <div class="custom-products-protection__inner">
              <div class="custom-products-protection__content">
                  <p class="custom-products-protection__title">${titleText}</p>
                  <p class="custom-products-protection__subtitle">${subtitleText}</p>
              </div>
              <div class="custom-products-protection__cost-wrap">
                  <span class="custom-products-protection__cost js-custom-pp-cost"></span>
                  <label class="toggle-control__wrap js-toggle-control">
                      <input type="checkbox" id="custom-pp-checkbox" checked="">
                      <span class="toggle-control">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="toggle-control-disable" viewBox="0 0 16 16">
                              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="toggle-control-active" viewBox="0 0 16 16">
                              <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
                          </svg>
                      </span>
                  </label>
              </div>
          </div>
      </div>
  `;

  // If the URL contains "tbyb", remove any existing PP items and skip the module
  if (
    window.location.href.toLowerCase().includes("tbyb") ||
    window.location.href.toLowerCase().includes("try-before-you-buy")
  ) {
    removePPFromCart();
    return;
  }

  async function removePPFromCart() {
    const ppUpdates = {};
    Object.values(dataProducts).forEach(function (variantId) {
      ppUpdates[variantId] = 0;
    });
    try {
      if (debug) {
        console.info("[PP] Removing PP from cart due to TBYB URL.");
      }
      const cart = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: ppUpdates }),
      });
      console.log(cart);
    } catch (error) {
      if (debug) {
        console.info("[PP] Error removing PP from cart:", error);
      }
    }
  }

  let moduleAllow = false;

  if (moduleActive) {
    $("#custom-pp-wrap").html(customBlock);
    moduleAllow = true;
    var itemCost = $(".js-custom-pp-cost");
  } else {
    var protectionValue = getURLParameter("productsprotection");

    if (protectionValue === "1") {
      $("#custom-pp-wrap").html(customBlock);
      moduleAllow = true;
    }
    var itemCost = $(".js-custom-pp-cost");
  }

  if (!moduleAllow) {
    if (debug) {
      console.info("[PP] Module not allowed, aborting.");
    }
    return;
  }

  var dataProductsPrice = {
    1: 2.34,
    2: (3.6).toFixed(2),
    3: (5.4).toFixed(2),
    4: (7.2).toFixed(2),
  };

  // All PP variant IDs as a Set for fast lookup
  const ppVariantIds = new Set(Object.values(dataProducts));

  // Re-entrancy guard: skip cart:updated events caused by our own updates
  let ppUpdating = false;

  // Track what's currently in the cart to avoid no-op fetches
  let currentPPInCart = null;

  // Track checkbox state in a variable so it survives cart drawer re-renders
  // (the DOM element gets reset to checked="" when the drawer re-renders)
  let ppChecked = true;

  $("#custom-pp-checkbox").prop("checked", true);

  $("#custom-pp-wrap").on("change", "#custom-pp-checkbox", function () {
    ppChecked = $(this).prop("checked");
    if (debug) {
      console.info("[PP] Checkbox:", ppChecked ? "ON" : "OFF");
    }
    // On checkbox toggle, we need a fresh cart to recalculate.
    // Use a single fetch, then process.
    fetch("/cart.js", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((r) => r.json())
      .then((cart) => handleCart(cart));
  });

  // Determine which PP variant should be in the cart based on total
  // (excluding PP items themselves from the total)
  function getDesiredPP(cart) {
    // Calculate total WITHOUT any PP items so tier doesn't self-inflate
    let total = 0;
    cart.items.forEach(function (item) {
      if (!ppVariantIds.has(item.id)) {
        total += item.final_line_price;
      }
    });
    total = total / 100;

    let tier = null;
    if (total >= 200) {
      tier = 4;
    } else if (total >= 150) {
      tier = 3;
    } else if (total >= 100) {
      tier = 2;
    } else if (total >= 3) {
      tier = 1;
    }

    return tier;
  }

  function handleCart(cart) {
    const tier = getDesiredPP(cart);
    const isChecked = ppChecked;

    // Update displayed price
    if (tier && isChecked) {
      itemCost.text("$" + dataProductsPrice[tier]);
    } else {
      itemCost.text("$0.00");
    }

    const desiredVariant = tier && isChecked ? dataProducts[tier] : null;

    if (debug) {
      console.info("[PP] Tier:", tier, "| Desired variant:", desiredVariant);
    }

    // Find what PP variant(s) are currently in the cart
    const ppItemsInCart = cart.items.filter((item) =>
      ppVariantIds.has(item.id),
    );
    const correctAlreadyInCart = ppItemsInCart.some(
      (item) => item.id === desiredVariant && item.quantity === 1,
    );
    const wrongItemsInCart = ppItemsInCart.filter(
      (item) => item.id !== desiredVariant,
    );

    // If the correct variant is already in cart with qty 1 and no wrong ones exist, do nothing
    if (correctAlreadyInCart && wrongItemsInCart.length === 0) {
      if (debug) {
        console.info("[PP] Cart already correct, no fetch needed.");
      }
      currentPPInCart = desiredVariant;
      return;
    }

    // If no PP desired and none in cart, do nothing
    if (!desiredVariant && ppItemsInCart.length === 0) {
      if (debug) {
        console.info("[PP] No PP needed and none in cart, skipping.");
      }
      currentPPInCart = null;
      return;
    }

    // We need to make a change — use a single /cart/update.js call
    cartAction(desiredVariant);
  }

  // Listen to cart:updated from cartDrawer — uses the cart data from the event
  // instead of fetching /cart.js again
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  const debouncedHandleCart = debounce(function (cart) {
    if (ppUpdating) {
      if (debug) {
        console.info(
          "[PP] Skipping cart:updated — our own update in progress.",
        );
      }
      return;
    }
    handleCart(cart);
  }, 300);

  document.addEventListener("cart:updated", (event) => {
    const cart = event.detail.cart || event.detail;
    debouncedHandleCart(cart);
  });

  // Single-fetch cart action: builds one /cart/update.js payload.
  // Always sets ALL PP variant IDs explicitly — every tier to 0, desired tier to 1.
  // This is fully idempotent: no matter the cart state or race conditions,
  // the result is always exactly one PP variant (or none).
  async function cartAction(desiredVariant) {
    if (ppUpdating) {
      if (debug) {
        console.info("[PP] cartAction already in progress, skipping.");
      }
      return;
    }

    ppUpdating = true;

    // Set ALL PP variants to 0, then override the desired one to 1
    const updates = {};
    Object.values(dataProducts).forEach(function (variantId) {
      updates[variantId] = 0;
    });
    if (desiredVariant) {
      updates[desiredVariant] = 1;
    }

    try {
      if (debug) {
        console.info("[PP] Sending single /cart/update.js:", updates);
      }

      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: updates }),
      });

      if (response.ok) {
        if (debug) {
          console.info("[PP] Cart updated successfully.");
        }
        currentPPInCart = desiredVariant;
      } else {
        if (debug) {
          const data = await response.json();
          console.info("[PP] Cart update failed:", data);
        }
      }
    } catch (error) {
      if (debug) {
        console.info("[PP] Error:", error);
      }
    } finally {
      // Release the re-entrancy guard after a short delay so the
      // resulting cart:updated event from cartDrawer is ignored
      setTimeout(function () {
        ppUpdating = false;
      }, 500);
    }
  }

  // Free shipping bar — listens to cart:updated (no extra fetches)
  document.addEventListener("cart:updated", (event) => {
    const cart = event.detail.cart || event.detail;
    const cartTotal = cart.total_price / 100;
    updateFreeShipping(cartTotal);
  });

  function updateFreeShipping(cartTotal) {
    if (debug) {
      console.info("[PP] Update freeShipping - $" + cartTotal);
    }
    let discountedPrice = 0;
    if (cartTotal >= 100) {
      discountedPrice = cartTotal * 0.75;
    } else if (cartTotal >= 50) {
      discountedPrice = cartTotal * 0.8;
    } else {
      discountedPrice = cartTotal * 0.85;
    }
    const shippingThreshold = 50;
    const remaining = shippingThreshold - discountedPrice;
    const title = $(".js-free-shipping-title");
    const line = $(".js-free-shipping-line span");
    var percent = 100 - (remaining * 100) / shippingThreshold;

    if (remaining >= 0) {
      title.html("<p>$<span>0</span> LEFT</p><p>FREE SHIPPING</p>");
      title.find("span").text(remaining.toFixed(2));
      line.css("width", percent + "%");
    } else {
      title.html("<p>FREE SHIPPING🎉</p>");
      line.css("width", "100%");
    }
  }
});
